(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Sidebar accordion toggle
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sidebar-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isExpanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isExpanded));
        var submenu = btn.nextElementSibling;
        if (submenu) {
          if (submenu.classList.contains('collection-sidebar__subsubmenu')) {
            submenu.classList.toggle('collection-sidebar__subsubmenu--open', !isExpanded);
          } else {
            submenu.classList.toggle('collection-sidebar__submenu--open', !isExpanded);
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // Sidebar accordion toggle (product pages)
  document.addEventListener('DOMContentLoaded', function () {
    function syncProductMobileMediaPlacement() {
      document.querySelectorAll('.product-with-sidebar').forEach(function (wrapper) {
        var grid = wrapper.querySelector('[data-product-grid-content]');
        var media = wrapper.querySelector('.product-information__media');
        var detailsContent = wrapper.querySelector('.product-details .group-block-content');

        if (!grid || !media || !detailsContent) {
          return;
        }

        if (!media.__pgOriginalParent) {
          media.__pgOriginalParent = grid;
          media.__pgOriginalNextSibling = media.nextElementSibling;
        }

        var isMobile = window.matchMedia('(max-width: 749px)').matches;

        if (isMobile) {
          var headerGroup = Array.prototype.find.call(detailsContent.children, function (child) {
            return child.classList && child.classList.contains('group-block');
          });

          if (headerGroup && media.parentNode !== detailsContent) {
            detailsContent.insertBefore(media, headerGroup.nextSibling);
          }

          media.classList.add('product-information__media--mobile-inline');
          return;
        }

        media.classList.remove('product-information__media--mobile-inline');

        if (media.parentNode === media.__pgOriginalParent) {
          return;
        }

        if (
          media.__pgOriginalNextSibling
          && media.__pgOriginalNextSibling.parentNode === media.__pgOriginalParent
        ) {
          media.__pgOriginalParent.insertBefore(media, media.__pgOriginalNextSibling);
        } else {
          media.__pgOriginalParent.appendChild(media);
        }
      });
    }

    document.querySelectorAll('[data-sidebar-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isExpanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isExpanded));
        var submenu = btn.nextElementSibling;
        if (submenu) {
          if (submenu.classList.contains('collection-sidebar__subsubmenu')) {
            submenu.classList.toggle('collection-sidebar__subsubmenu--open', !isExpanded);
          } else {
            submenu.classList.toggle('collection-sidebar__submenu--open', !isExpanded);
          }
        }
      });
    });

    syncProductMobileMediaPlacement();
    window.addEventListener('resize', syncProductMobileMediaPlacement);
  });

  } catch(e) { console.error(e); }
})();
})();
